export default [
  {
    path: "/master/jenis-kegiatan/",
    component: () =>
      import("@/pages/master/jenis-kegiatan/jenis-kegiatan-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/master/rekening-koran/",
    component: () =>
      import("@/pages/master/rekening-koran/rekening-koran-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/master/rekening-koran/import",
    component: () =>
      import("@/pages/master/rekening-koran/rekening-koran-import.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/master/data-potensial/",
    component: () => import("@/pages/master/potential/potential-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/master/instansi",
    component: () => import("@/pages/master/instansi/instansi-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/master/target-realisasi",
    component: () =>
      import("@/pages/master/realization-target/target-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
];
